import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import MobileHeader from "../../layout/AuthLayout/MobileHeader";
import AuthFooter from "../../layout/AuthLayout/Footer";

export default function NotifsPage() {
  const divRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return (
    <>
      <MobileHeader title="اعلان ها" hasScroll={hasScroll} />

      <Box
        ref={divRef}
        sx={{
          // minWidth: "480px",
          maxWidth: "600px",
          width: {
            xs: "100%",
          },
          marginX: "auto",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          paddingX: "8px",
          paddingTop: "20px",
          overflow: "hidden",
        }}
      >
        <Outlet />
        <AuthFooter />
      </Box>
    </>
  );
}
